// @ts-nocheck
// TODO: tighten types after migration
import React from "react";
import { Helmet } from "react-helmet";
import Header from "../Header";
import Footer from "../footer";
import PodcastHome from "./PodcastHome";
import SEO from "../Blog/SEO";
import { generatePodcastSeriesStructuredData } from "../utils/structuredData";
import useFavicon from "../utils/useFavicon";

export default function Podcast() {
    useFavicon("/images/home_images/Podcast 1 Thumbnail 4K.jpg");
    const podcastSeriesSchema = generatePodcastSeriesStructuredData();

    return (
        <>
            <SEO
                title="Podcast – Inspiring Conversations on Tech, Life & Growth"
                description="Tune in to Hari Vishnu's podcast for inspiring conversations, expert interviews, and stories from the world of technology, creativity, and personal development."
                url="https://podcast.harivishnu.in"
                keywords="podcast, interviews, technology, creativity, personal development, inspiring conversations, Hari Vishnu"
            />
            <Helmet>
                <script type="application/ld+json">
                    {JSON.stringify(podcastSeriesSchema)}
                </script>
            </Helmet>
            <Header />
            <PodcastHome />
            <Footer />
        </>
    );
}